import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaSummary = async ({ patientId, trialId, mediaType }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/photos/get_external_media_summary/`, {
    params: { patientId, trialId, media_type: mediaType },
    headers: { Authorization: `Token ${token}` },
  });

  return res.data;
};

const useGetExternalMediaSummary = ({ patientId, trialId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["external-media-summary", patientId, trialId, mediaType],
    queryFn: () => fetchExternalMediaSummary({ patientId, trialId, mediaType }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
  });
};

export default useGetExternalMediaSummary;
